import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import * as Types from 'types';
import { setPlayerPlaylistData } from 'features/player/actions';
import { getPlaylistParamsFromUrl } from 'player/services/getPlaylistParamsFromUrl';

type StateProps = {
  playlistId?: string;
  playlistItemId?: string;
};

type DispatchProps = {
  setPlayerPlaylistData: typeof setPlayerPlaylistData;
};

type Props = StateProps & DispatchProps;

/**
 * Listen to URL changes and writes to state
 */
const URLReceiverComponent: React.FC<Props> = (props) => {
  const { playlistId, playlistItemId } = getPlaylistParamsFromUrl();

  useEffect(() => {
    props.setPlayerPlaylistData(playlistId, playlistItemId);
  }, [playlistId, playlistItemId]);

  return null;
};

const mapStateToProps = ({ player }: Types.RootState) => ({
  playlistId: player.playlistId,
  playlistItemId: player.playlistItemId,
});

const mapDispatchToProps = { setPlayerPlaylistData };

const URLReceiver = connect(
  mapStateToProps,
  mapDispatchToProps,
)(URLReceiverComponent);

export const QueryStringToState: React.FC<{}> = () => (
  // Wrap in Route to kick re-render on location change
  <Route component={URLReceiver} />
);
